import moment from 'moment'

// 时间戳 => 年月日 时分
export function dateAndMinTime(timestap) {
    if (timestap) {
      return moment(timestap).format('YYYY-MM-DD HH:mm')
    } else {
      return '无值'
    }
  }


// WEBPACK FOOTER //
// ./src/utils/filter.js